export const TOKENS_REFRESH_INTERVAL = 15 * 60000 // 15 mins, assuming token list is not changed frequently.
export const BALANCES_REFRESH_INTERVAL = 1 * 60000 // 1 min
